import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function ForgotPassword() {
  const [emailSent, setEmailSent] = useState(false);
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setErrorMessage('');
    
    try {
      // Utilisation de l'URL relative comme dans Login.jsx
      const response = await fetch('/api/auth/forgot-password', {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email })
      });

      if (response.ok) {
        setEmailSent(true);
      } else {
        const errorData = await response.json().catch(() => ({}));
        setErrorMessage(errorData.error || "Une erreur est survenue");
      }
    } catch (error) {
      console.error("Erreur lors de l'envoi :", error);
      setErrorMessage("Impossible de communiquer avec le serveur. Veuillez réessayer plus tard.");
    } finally {
      setIsLoading(false);
    }
  };

  
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4 font-sans text-left">
      <div className="max-w-md w-full bg-white p-8 rounded-3xl shadow-xl">
        <h2 className="text-2xl font-bold text-slate-800 mb-2">Récupération</h2>
        {!emailSent ? (
          <form onSubmit={handleSubmit} className="animate-in fade-in duration-500">
            <p className="text-slate-500 text-sm mb-6">
              Entrez votre email pour recevoir un lien de réinitialisation sécurisé.
            </p>
            <div className="space-y-4">
              <input 
                type="email" 
                required 
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full border border-slate-200 rounded-xl p-3 outline-none focus:ring-2 focus:ring-cyan-500 transition" 
                placeholder="votre@email.com" 
                disabled={isLoading}
              />
              {errorMessage && (
                <div className="text-red-600 text-xs bg-red-50 p-2 rounded-lg">
                  ⚠️ {errorMessage}
                </div>
              )}
              <button 
                type="submit"
                disabled={isLoading}
                className="w-full bg-slate-900 text-white py-3 rounded-xl font-bold hover:bg-slate-800 transition shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isLoading ? 'Envoi en cours...' : 'Envoyer le lien'}
              </button>
            </div>
          </form>
        ) : (
          <div className="text-center animate-in zoom-in duration-300">
            <div className="text-5xl mb-4">📩</div>
            <div className="text-green-600 font-bold mb-2 text-lg">Vérifiez vos emails</div>
            <p className="text-slate-500 text-sm mb-6">
              Un lien a été envoyé à <strong>{email}</strong>. Il expirera dans 15 minutes.
            </p>
          </div>
        )}
        
        <div className="mt-8 text-center border-t pt-4">
          <Link to="/login" className="text-sm text-cyan-600 hover:underline font-medium">
            Retour à la connexion
          </Link>
        </div>
      </div>
    </div>
  );
}